import { render, staticRenderFns } from "./TelRecord.vue?vue&type=template&id=6d990a06&scoped=true"
import script from "./TelRecord.vue?vue&type=script&lang=js"
export * from "./TelRecord.vue?vue&type=script&lang=js"
import style0 from "./TelRecord.vue?vue&type=style&index=0&id=6d990a06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d990a06",
  null
  
)

export default component.exports